<template>
  <b-navbar toggleable="lg" fixed="top" class="header-area text-white">
    <div class="container-fluid container-fluid--cp-150">
      <b-navbar-brand
        class="navbar-brand logo-light"
        @click="
          sfxClick();
          $router.push('home');
        "
      >
        <img src="/logo.png" style="width: 80px" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-collapse
        class="default-nav"
        is-nav
        id="nav_collapse"
        style="justify-content: right"
      >
        <b-navbar-nav class="navbar-nav main-menu text-white text-capitalize">
          <v-select
            filled
            outlined
            background-color="white"
            label="Session Type"
            dense
            :items="$sessions"
            class="mt-3 ml-3"
            style="width: 250px"
            v-model="session"
            hide-details
            @change="setSession"
          ></v-select>
          <!-- <v-select
            filled
            outlined
            background-color="white"
            dense
            :items="$dates"
            class="mt-3 ml-3"
            style="width: 150px"
            v-model="date"
            hide-details
          ></v-select> -->
          <v-text-field
            filled
            outlined
            background-color="white"
            :placeholder="'Search by Title or Author...'"
            dense
            class="mt-3 ml-3"
            style="width: 280px"
            v-model="keySearch"
            @input="setKeySearch"
            hide-details
            label="Search Articles"
          ></v-text-field>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
import { database } from "@/plugins/firebase";
import moment from "moment";

export default {
  computed: {
    isVn() {
      return this.$store.getters["Lang/getLang"] == "vi";
    },
  },
  data() {
    return {
      showBtnBag: false,
      room: "",
      date: moment().format("DD"),
      keySearch: "",
      session: "",
    };
  },
  created() {
    this.checkedin();
  },
  methods: {
    setRoom() {
      this.$store.commit("Article/SET_ROOM", this.room);
    },
    setDate() {
      this.$store.commit("Article/SET_DATE", this.date);
    },
    setKeySearch() {
      this.$store.commit("Article/SET_KEYSEARCH", this.keySearch);
    },
    setSession() {
      this.$store.commit("Article/SET_SESSION", this.session);
    },
    openSandrasoft() {
      window.location.href =
        "https://console.feelingme.app/register?companyid=09C3AD56-5080-4B25-B8D2-DAF6DDECA0D7";
    },
    async checkedin() {
      var checkedin = await this.$dbGet(
        database,
        `users/${this.userID}/checkedin`
      );
      if (checkedin) {
        this.showBtnBag = true;
      }
    },
  },
};
</script>
